import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import UnlockPDFImagesListScreen from "./UnlockPDFImagesListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function UnlockPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Unlock PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/unlock_pdf", title: "Remove PDF Password" },
    data2: { link: "/unlock_pdf", title: "PDF Unlock" },
    data3: { link: "/unlock_pdf", title: "Decrypt PDF files" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Unlock PDF files online instantly. Remove PDF passwords, disable restrictions, and access secured documents quickly with our safe PDF unlock tool."
      ></meta>
      <meta
        name="keywords"
        content="unlock pdf, remove pdf password, pdf unlock, unlock pdf online, remove password from pdf, pdf password remover, decrypt pdf, unprotect pdf, pdf security remover, unlock secured pdf, pdf restriction remover, pdf unlock tool, remove pdf protection, unlock pdf free, pdf editor online, open locked pdf, pdf password breaker,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <UnlockPDFImagesListScreen title={title}></UnlockPDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Unlock PDF Offline Tool is a reliable and efficient solution designed to help users remove password protection and usage restrictions from PDF files without requiring an internet connection. This powerful offline PDF unlock software enables users to easily unlock secured PDF documents, remove password from PDF, and eliminate editing, printing, and copying restrictions while regaining full access to their files with complete data privacy. Since the entire process runs locally on your device, it ensures maximum security and removes the risk of uploading sensitive documents online, making it ideal for confidential business files, legal documents, invoices, research papers, and personal records. With fast processing speed, high success rates, and support for all major operating systems, this tool can unlock PDF files quickly, even for large or complex documents. Its intuitive interface allows both beginners and professionals to remove PDF passwords in just a few clicks. Whether you are searching for an offline PDF password remover, remove password from PDF offline, unlock PDF without internet, remove PDF security offline, decrypt PDF files locally, or PDF restriction remover tool, this offline PDF unlocking solution delivers convenience, privacy, and high performance, making it a top choice for seamless and secure PDF access." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Unlock",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Unlock PDF tool"
            why_use={[
              {
                title: "Data Privacy & Security",
                description:
                  "Our offline PDF unlock tool works locally on your device, ensuring sensitive or confidential documents are not uploaded to third-party servers or exposed to data breaches.",
              },
              {
                title: "No Internet Dependency",
                description:
                  "This website allows users to unlock PDF files without internet access, making it ideal for secure environments, remote locations, or restricted networks.",
              },
              {
                title: "Remove Forgotten Passwords",
                description:
                  "Our website helps users to remove password from PDF files when the password is lost or forgotten, saving time and preventing data loss.",
              },

              {
                title: "Regain Editing & Printing Access",
                description:
                  "Easily removes restrictions on editing, copying, and printing so users can fully reuse their own PDF documents.",
              },
              {
                title: "Faster Processing",
                description:
                  "Offline PDF unlocking is usually faster since files are processed directly on the system without upload or download delays.",
              },
              {
                title: "Safe for Confidential Documents",
                description:
                  "Perfect for legal, financial, medical, academic, and business PDFs where privacy and compliance are critical.",
              },
              {
                title: "Works Anytime, Anywhere",
                description:
                  "Since it does not rely on online services, users can unlock PDF files even in offline or high-security environments.",
              },
              {
                title: "Cost-Effective Solution",
                description:
                  "Eliminates the need for paid online services or repeated subscriptions to unlock secured PDFs.",
              },
              {
                title: "User-Friendly Operation",
                description:
                  "Our offline tools offer a simple interface, allowing anyone to remove PDF passwords in just a few clicks.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What is a PDF unlocker?",
                description:
                  "A PDF unlocker is a tool that removes supported password or usage restrictions from a PDF document when the required credentials and permissions are available. The ability to unlock a file depends on its encryption and security settings.",
              },
              {
                title: "How can I unlock a PDF for free?",
                description:
                  "Open the PDF unlock tool on ShivaPDF.com, select your protected PDF, and provide the password if required. Start the unlocking process and download the unlocked document if the file can be processed successfully.",
              },
              {
                title: "Can I unlock a PDF offline?",
                description:
                  "Yes, if the PDF unlocker supports local processing, you may be able to unlock supported PDF files without an internet connection after the tool and its required resources have loaded. Offline availability depends on the implementation.",
              },
              {
                title: "Does ShivaPDF upload my PDF when unlocking it?",
                description:
                  "A locally processed PDF unlocker can handle supported documents directly in your browser without sending them to a server. Check the tool's implementation and privacy policy to confirm how your files and passwords are handled.",
              },
              {
                title: "Can I unlock a PDF without a password?",
                description:
                  "Some PDFs have usage restrictions but can be processed without a password, while PDFs encrypted with an opening password generally require the correct password. A PDF unlocker cannot guarantee access to every protected document.",
              },
              {
                title: "Do I need the original password to unlock a PDF?",
                description:
                  "If a PDF requires a password to open, you generally need the correct password to decrypt it. The requirements for removing printing, copying, or editing restrictions depend on the document's encryption and the tool's capabilities.",
              },
              {
                title: "What is the difference between a PDF opening password and a permissions password?",
                description:
                  "An opening password restricts access to the PDF itself. A permissions password controls certain actions, such as printing, copying, or editing, in PDF security systems that support those restrictions.",
              },
              {
                title: "Can I remove PDF printing restrictions?",
                description:
                  "A compatible PDF tool may remove printing restrictions when the required credentials and permissions are available. Only remove restrictions when you are authorized to modify the document.",
              },
              {
                title: "Can I remove PDF copying restrictions?",
                description:
                  "Some PDF security settings restrict copying text or images. Whether those restrictions can be removed depends on the encryption, required password, and capabilities of the unlocking tool.",
              },
              {
                title: "Can I unlock a PDF that is password-protected?",
                description:
                  "Yes, a PDF unlocker may unlock a password-protected document when the correct password is supplied and its encryption is supported. If the password is unknown, recovery may not be possible.",
              },
              {
                title: "Can I unlock a PDF without changing its content?",
                description:
                  "Unlocking a PDF is intended to change its security settings rather than its visible content. However, document properties or other security-related information may change, so review the output after unlocking.",
              },
              {
                title: "Will unlocking a PDF reduce its quality?",
                description:
                  "Removing PDF protection does not normally require reducing image or text quality. However, results depend on the processing method, so check that the unlocked document displays correctly.",
              },
              {
                title: "Can I unlock a scanned PDF?",
                description:
                  "A scanned PDF can often be unlocked if its security settings are supported by the tool. Scanned pages usually contain images, and unlocking the document does not automatically make the text searchable.",
              },
              {
                title: "Can I unlock a PDF on my phone?",
                description:
                  "You can unlock supported PDF files on a compatible iPhone or Android device using a mobile-friendly browser-based tool. Open ShivaPDF.com, select your document, and follow the available unlocking steps.",
              },
              {
                title: "Can I unlock a PDF on Windows or Mac?",
                description:
                  "A browser-based PDF unlocker can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser and select the protected PDF you are authorized to unlock.",
              },
              {
                title: "Can I unlock a PDF without installing software?",
                description:
                  "A browser-based PDF unlocker lets you process supported documents without installing a separate desktop application. The available features depend on the tool's capabilities and your browser.",
              },
              {
                title: "Is ShivaPDF's PDF unlocker free?",
                description:
                  "ShivaPDF provides browser-based PDF tools for common document tasks. Check the unlock PDF page for current availability, supported encryption types, file-size limits, and any usage restrictions.",
              },
              {
                title: "Can I unlock a PDF without creating an account?",
                description:
                  "You may be able to unlock supported PDFs without registration if the tool does not require an account. Check the current ShivaPDF page for access requirements and any applicable limits.",
              },
              {
                title: "Why can't I unlock my PDF?",
                description:
                  "The PDF may require an incorrect or missing password, use unsupported encryption, be corrupted, or have restrictions the tool cannot remove. Verify the password and document permissions before trying again.",
              },
              {
                title: "Can every password-protected PDF be unlocked?",
                description:
                  "No. Some PDFs use encryption or security settings that a particular tool cannot process. An opening password may be required, and successful unlocking cannot be guaranteed for every document.",
              },
              {
                title: "Can I unlock a PDF and keep the original file?",
                description:
                  "Yes, if the tool produces a separate unlocked PDF, you can keep the original protected document unchanged. Keeping the original is useful if you need to preserve its existing security settings.",
              },
              {
                title: "Is it safe to unlock confidential PDF documents online?",
                description:
                  "For confidential documents, choose a tool with a clear privacy policy and verified local processing if you want files to remain on your device. Avoid submitting sensitive documents or passwords to services unless you understand how they are handled.",
              },
              {
                title: "Is it legal to unlock a PDF?",
                description:
                  "Unlock PDFs only when you own the document or have permission to remove its restrictions. Laws, licensing terms, and document-owner requirements can vary, so make sure you are authorized to make the change.",
              },
              {
                title: "How do I save an unlocked PDF?",
                description:
                  "After the unlocking process completes, use the tool's download or save option to obtain the unlocked PDF. Open the downloaded file and verify that it works as expected and has the intended security settings.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1623109999}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default UnlockPDFMain;
